module.exports = __webpack_public_path__ + "static/img/01-works.8193c551.jpg";